import axios from "../axios";
const END_POINT = "/messages";

const addMessage = (message) => axios.post(`${END_POINT}`, message);
const getMessages = (payload) => axios.get(`${END_POINT}` , payload);
const getOneMessage = (messageId) => axios.get(`${END_POINT}/${messageId}`);
const updateMessage = (messageId, payload) =>
  axios.patch(`${END_POINT}/${messageId}`, payload);

export { addMessage, getMessages, getOneMessage, updateMessage };
